import React, { Component } from 'react';

class Toast extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toasts: [],
    };
    this.handleToast = this.handleToast.bind(this);
    this.nextId = 0;
  }

  componentDidMount() {
    window.addEventListener('toast', this.handleToast);
  }

  componentWillUnmount() {
    window.removeEventListener('toast', this.handleToast);
  }

  handleToast(e) {
    var detail = e.detail || {};
    var text = detail.text || '';
    var type = detail.type || 'info';
    var id = ++this.nextId;

    this.setState(function(prev) {
      return { toasts: prev.toasts.concat([{ id: id, text: text, type: type, fading: false }]) };
    });

    // Start fade out after 2.5s
    var self = this;
    setTimeout(function() {
      self.setState(function(prev) {
        return {
          toasts: prev.toasts.map(function(t) {
            return t.id === id ? Object.assign({}, t, { fading: true }) : t;
          }),
        };
      });
    }, 2500);

    // Remove after 3s
    setTimeout(function() {
      self.setState(function(prev) {
        return {
          toasts: prev.toasts.filter(function(t) { return t.id !== id; }),
        };
      });
    }, 3000);
  }

  render() {
    var bgColors = {
      success: 'tw-bg-green-600',
      error: 'tw-bg-red-600',
      info: 'tw-bg-brand-gold',
    };

    return (
      <div role="status" aria-live="polite" aria-atomic="true" style={{ position: 'fixed', top: '76px', left: '1rem', right: '1rem', zIndex: 99999, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem', pointerEvents: 'none' }}>
        {this.state.toasts.map(function(toast) {
          var bgClass = bgColors[toast.type] || bgColors.info;
          return (
            <div
              key={toast.id}
              className={bgClass}
              style={{
                padding: '10px 20px',
                borderRadius: '100px',
                color: 'white',
                fontWeight: 600,
                fontSize: '13px',
                boxShadow: '0 4px 16px rgba(0,0,0,0.25)',
                transition: 'opacity 0.4s ease, transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
                opacity: toast.fading ? 0 : 1,
                transform: toast.fading ? 'translateY(-8px) scale(0.95)' : 'translateY(0) scale(1)',
                maxWidth: '320px',
                pointerEvents: 'auto',
              }}
            >
              {toast.text}
            </div>
          );
        })}
      </div>
    );
  }
}

export default Toast;
